import { defaultCustomerState } from '../../models/redux/DefaultCustomerState';
import {
  GET_MY_CUSTOMERS_ERROR,
  GET_MY_CUSTOMERS_RECEIVE,
  GET_MY_CUSTOMERS_REQUEST
} from './types';

const CustomerReducer = (state = defaultCustomerState, action: any) => {
  switch (action.type) {
    case GET_MY_CUSTOMERS_REQUEST: {
      state = {
        ...state,
        myCustomers: [],
        myCustomersLoading: true
      };
      break;
    }
    case GET_MY_CUSTOMERS_RECEIVE: {
      state = {
        ...state,
        myCustomersLoading: false,
        myCustomers: action.payload
      };
      break;
    }
    case GET_MY_CUSTOMERS_ERROR: {
      state = {
        ...state,
        myCustomersLoading: false
      };
      break;
    }
  }

  return state;
};

export { CustomerReducer };
